export enum AtomLinkTypeEnum {
  PRIMARY = "primary",
  DARK = "dark",
  SECONDARY = "secondary",
  LINK = "link",
}
